import { render, staticRenderFns } from "./YAxisForm.vue?vue&type=template&id=2f846be0&"
import script from "./YAxisForm.vue?vue&type=script&lang=js&"
export * from "./YAxisForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports